// extracted by mini-css-extract-plugin
export default {"container":"wq-z","brandName":"xq-z","productName":"yq-z","productNamePdpEnhancements":"zq-z","breakLongProductName":"Aq-z"};